import type { TourDefinition } from "@/types/tour";

export const entrepreneurApplications: TourDefinition = {
  id: "entrepreneur-applications",
  context: "entrepreneur",
  version: 1,
  path: "/applications",
  steps: [
    {
      element: '[data-tour-id="opportunities-stats"]',
      popover: {
        title: "Application stats",
        description:
          "Track your application activity — total submissions, recent applications, and average match scores.",
      },
    },
    {
      element: '[data-tour-id="opportunities-list"]',
      popover: {
        title: "Your applications",
        description:
          "All the opportunities you've applied to are listed here with their current status and scores.",
      },
    },
    {
      element: '[data-tour-id="opportunities-filters"]',
      popover: {
        title: "Filter applications",
        description:
          "Narrow down your applications by sector to find what you're looking for.",
      },
    },
    {
      element: '[data-tour-id="opportunity-card-first"]',
      popover: {
        title: "View application details",
        description:
          "Click any application to see the full opportunity details and check for reviewer feedback.",
      },
    },
  ],
};
